import { getApiClient } from "@punchup/utils/apiRegistry";
import { genAbsoluteURL } from "@punchup/utils/genAbsoluteURL";

import { logException } from "@punchup/sentry";

export const WAITLIST_QUERY_KEYS = {
  perShow: "waitlist-status",
  batched: "multiple-waitlist-status",
  dashboard: "waitlist",
} as const;

export interface WaitlistSubscription {
  id: string;
  show_id: string;
  email: string | null;
  phone: string | null;
  created_at: string;
  receive_updates: boolean | null;
}

export interface FetchWaitlistStatusParams {
  showId: string;
  userEmail?: string;
  userPhone?: string;
}

export interface FetchMultipleWaitlistStatusParams {
  showIds: string[];
  userEmail?: string;
  userPhone?: string;
}

export async function fetchWaitlistStatus(
  params: FetchWaitlistStatusParams
): Promise<WaitlistSubscription | null> {
  try {
    const searchParams = new URLSearchParams({
      showIds: params.showId,
    });

    const url = `/api/v2/user/waitlist?${searchParams.toString()}`;
    const { data } = await getApiClient().get<{ data: WaitlistSubscription[] }>(
      url
    );

    return data?.[0] || null;
  } catch (error) {
    logException(error, {
      tags: {
        showId: params.showId,
      },
    });
    return null;
  }
}

export async function fetchMultipleWaitlistStatus(
  params: FetchMultipleWaitlistStatusParams
): Promise<WaitlistSubscription[]> {
  try {
    if (params.showIds.length === 0) {
      return [];
    }

    const searchParams = new URLSearchParams({
      showIds: params.showIds.join(","),
    });

    const url = genAbsoluteURL(
      `/api/v2/user/waitlist?${searchParams.toString()}`
    );

    const response = await fetch(url);

    if (!response.ok) {
      console.error(
        "Multiple waitlist status fetch failed:",
        response.status,
        response.statusText
      );
      return [];
    }

    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error("Error fetching multiple waitlist status:", error);
    return [];
  }
}
